import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useHasPermission } from "../utils/permissionUtils";
import cwReports from "./cw-reports";
import adaScans from "./ada-scans";

const plugins = [cwReports, adaScans];

export const useEnabledPlugins = () => {
    const enabledIds = useSelector((state) => state.auth.plugins);
    return useMemo(() => plugins.filter((plugin) => enabledIds.includes(plugin.id)), [enabledIds]);
};

export const useInternalPlugins = () => {
    const hasPermission = useHasPermission();
    const canSeeInternal = hasPermission("canSeeInternal");
    return useMemo(() => (canSeeInternal ? plugins.filter((plugin) => plugin.internal) : []), [canSeeInternal]);
};

export default plugins;
